import { useQuery } from '@tanstack/react-query';
import { getCycleById } from 'services/api/requests/cycle';

export const useGetCycle = (id?: string | number) => {
	return useQuery(['cycle', id], getCycleById, {
		refetchOnWindowFocus: false,
		enabled: !!id,
	});
};
